import Continue from '../continue';
import CancelOrder from '../cancelOrder';
import Locked from '../lockedOrder';
import View from '../view';

export const actionsRest = {
  INCOMPLETE: [Continue, CancelOrder],
  ORDER_VALIDATED: [Locked],
  PENDING_VALIDATION: [View],
  WAITING_ON_SALES: [View, Continue],
  ORDER_CANCELED: [Locked],
  CANCELED_BY_SALESREP: [Locked]
};
